
import { artworks } from '../../vue'

export default {
	namespace: 'artworks',
	beforeEnter() {

	},
	afterEnter() {

		console.log('artworks barba?')

		// Load Artworks Vue Instance
		artworks()

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
